export default "__VITE_ASSET__4ABqQuCR__"